
import { Vue, Component, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import SelectDistributorModal from './SelectDistributorModal.vue';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';

@Component({
  components: {
    SelectDistributorModal,
  },
})
export default class SalesPlanFormModal extends Vue {
  visible = false;

  isEdit = false;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  goods: any = null;

  record: any = null;

  // 弹窗选中的经销商 id 集合，提交时随表单一并带出，并展示在适用经销商文本域
  distributorIds: any[] = [];

  form: any = {
    plan_name: '',
    agent_price: '',
    supplier_price: '',
    shop_price: '',
    price: '',
    distributor_ids: '',
  };
  rules: any = {
    plan_name: [
      { required: true, message: '请输入销售方案名称', trigger: 'blur' },
    ],
    agent_price: [
      { required: true, message: '请输入省运营中心执行价', trigger: 'blur' },
      {
        pattern: /^\d+(\.\d{1,2})?$/,
        message: '省运营中心执行价最多保留两位小数',
        trigger: 'blur',
      },
    ],
    supplier_price: [
      { required: true, message: '请输入地区服务商建议价', trigger: 'blur' },
      {
        pattern: /^\d+(\.\d{1,2})?$/,
        message: '地区服务商建议价最多保留两位小数',
        trigger: 'blur',
      },
    ],
    shop_price: [
      { required: true, message: '请输入门店采购建议价', trigger: 'blur' },
      {
        pattern: /^\d+(\.\d{1,2})?$/,
        message: '门店采购建议价最多保留两位小数',
        trigger: 'blur',
      },
    ],
    price: [
      { required: true, message: '请输入建议零售价', trigger: 'blur' },
      {
        pattern: /^\d+(\.\d{1,2})?$/,
        message: '建议零售价最多保留两位小数',
        trigger: 'blur',
      },
    ],
  };

  @Ref('ruleForm')
  private ruleForm!: FormModel;

  @Ref('selectDistributorModal')
  selectDistributorModal!: SelectDistributorModal;

  async open(goods: any, record?: any) {
    this.goods = goods || null;
    this.isEdit = !!record;
    this.record = record || null;
    if (this.isEdit) {
      const res = await this.supplyService.getCommodityPlanDetail({
        id: record.id,
      });
      const distributor_ids = res.distributor_map;
      const distributorIds = Object.keys(distributor_ids);
      this.form = {
        plan_name: res.detail.plan_name || '',
        agent_price: res.detail.agent_price || '',
        supplier_price: res.detail.supplier_price || '',
        shop_price: res.detail.shop_price || '',
        price: res.detail.price || '',
        distributor_ids: distributorIds.join(','),
        id: res.detail.id,
      };
    } else {
      this.form = {
        plan_name: '',
        agent_price: '',
        supplier_price: '',
        shop_price: '',
        price: '',
        distributor_ids: null,
        status: 1,
      };
    }

    this.visible = true;
    this.distributorIds = [];
    this.$nextTick(() => {
      this.ruleForm && this.ruleForm.clearValidate('');
    });
  }

  openSelectDistributor() {
    const ids = (this.form.distributor_ids || '')
      .split(',')
      .filter((id: string) => id !== '')
      .map((id: string) => Number(id));
    this.selectDistributorModal.open(ids);
  }

  onDistributorConfirm(ids: any[]) {
    this.distributorIds = [...ids];
    this.form.distributor_ids = ids.join(',');
  }

  handleOk() {
    this.ruleForm.validate(async (valid) => {
      if (!valid) {
        return false;
      }
      // 接口返回冲突经销商数组，service 中误标为 string，此处显式标注
      const res: any = await this.supplyService.postCommodityPlanCheck({
        commodity_id: this.goods.id,
        plan_id: this.form.id || 0,
        distributor_ids: this.form.distributor_ids,
      });
      if (res.length > 0) {
        // 存在已归属其他销售方案的经销商，二次确认后再保存
        this.$confirm({
          title: '提示',
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          content: (h: any) =>
            h(
              'div',
              res.map((item: any) =>
                h(
                  'p',
                  [
                    h('span', { style: { color: 'red' } }, item.distributor_name),
                    ' 已属于销售方案“',
                    h('span', { style: { color: 'red' } }, item.existing_plan_name),
                    '”，继续保存将改属当前方案',
                  ],
                ),
                // eslint-disable-next-line function-paren-newline
              ),
            ),
          onOk: () => this.commodityFunction(true),
        });
      } else {
        this.commodityFunction();
      }

      // if (this.isEdit) {
      //   // TODO: 调用编辑销售方案接口，参数：this.record、this.form、this.distributorIds

      //   this.$message.success('编辑成功');
      // } else {
      //   // TODO: 调用新增销售方案接口，参数：this.goods、this.form、this.distributorIds
      //   this.$message.success('新增成功');
      // }
    });
  }

  async commodityFunction(force?: boolean) {
    const item = await this.supplyService.postCommodityPlanEdit({
      id: this.record?.id,
      plan_name: this.form.plan_name,
      agent_price: this.form.agent_price,
      supplier_price: this.form.supplier_price,
      shop_price: this.form.shop_price,
      price: this.form.price,
      distributor_ids: this.form.distributor_ids,
      commodity_id: this.goods.id,
      unit: this.goods.unit,
      force,
    });
    this.visible = false;
    this.$emit('refresh');
    console.log('item', item);
  }

  handleCancel() {
    this.visible = false;
    this.ruleForm.resetFields();
  }
}
